import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CellComponent} from '@spartacus/organization/administration/components';
import { PopoverDirective } from '@spartacus/storefront';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-org-permission-details-cell',
    templateUrl: './efa-permission-details-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PopoverDirective, TranslatePipe]
})
export class EfaPermissionDetailsCellComponent extends CellComponent {
}
